import { SubmissionError } from 'redux-form';
import { useLocation } from 'react-router-dom';

import { user } from 'services';
import { useUiVersion } from 'hooks';
import { LangSelector, ThemeChanger, UiVersionSwitch } from 'libs/ui';
import { LoginForm } from './form';
import { AuthV2 } from './auth.v2';
import { Content, Line } from './auth.styled';

export const Auth = () => {
  const location = useLocation();
  const referrer = location.state?.referrer;
  const { isNew } = useUiVersion();

  /**
   * login
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    return user.login(values, referrer ?? '/').catch((error) => {
      throw new SubmissionError({
        _error: error,
      });
    });
  };

  if (isNew) {
    return <AuthV2 />;
  }

  return (
    <Content>
      <img src="/images/auth-logo.png" alt="CLEVER PARK" />
      <Line>
        <ThemeChanger withBg />
        <LangSelector />
      </Line>
      <LoginForm onSubmit={submit} />
      <Line style={{ margin: '24px auto 0' }}>
        <UiVersionSwitch />
      </Line>
    </Content>
  );
};
